// Inspired by: https://github.com/excid3/tailwindcss-stimulus-components/blob/master/src/popover.js

import { Controller } from "@hotwired/stimulus";

export default class UIToggleController extends Controller {
  connect() {}

  toggle() {
    const button = this.element.querySelector("button");
    const span = this.element.querySelector("span");
    const input = this.element.querySelector("input[type='hidden']");

    if (this.element.dataset.state == "checked") {
      input.value = "false";
      button.dataset.state = "unchecked";
      button.setAttribute("aria-checked", "false");
      span.dataset.state = "unchecked";
      this.element.dataset.state = "unchecked";
    } else {
      input.value = "true";
      button.dataset.state = "checked";
      button.setAttribute("aria-checked", "true");
      span.dataset.state = "checked";
      this.element.dataset.state = "checked";
    }
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
